import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import ClaimsPage from '@/components/pages/claims';

const ProtectedClaims = withAuthenticationRequired(ClaimsPage, {
  onRedirecting: () => <Loading />,
});

export const Route = createFileRoute('/claims/')({
  head: () => ({
    meta: [{ title: `Claims | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedClaims,
});
